import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { capitalizeWords } from 'utils/helpers';
import { ADMIN_ROUTES } from 'constants/routes';
import { Col, Row, Typography } from 'components';
import { useNotifications } from 'hooks/useNotifications';
import { useNotificationApi } from 'hooks/useNotificationApi';
import { TypeOfNotificationEntityType } from 'models/Notification';
import { NotificationsEmptyIcon } from 'components/common/icons/NotificationsEmptyIcon';
import styles from './styles.module.scss';

type Props = { userId: string };

export const NOTIFICATION_TYPE_MAPPING: Record<string, string> = {
  ASSIGNED: ' to you.',
  UNASSIGNED: ' from you.',
};

export function NotificationToaster({ userId }: Props) {
  const notificationApi = useNotificationApi();
  const navigate = useNavigate();

  const onRedirectToEntity = useCallback(
    (id: string, entityName: TypeOfNotificationEntityType) => {
      switch (entityName) {
        case 'BRAND':
          navigate(`${ADMIN_ROUTES.brand.view}/${id}/management`);
          return;
        case 'CLIENT':
          navigate(`${ADMIN_ROUTES.client}/${id}/general`);
          return;
        case 'LEAD':
          navigate(`${ADMIN_ROUTES.leads.view}/${id}/general`);
          return;
        case 'DEAL':
          navigate(`${ADMIN_ROUTES.deals.view}/${id}/purchase-request`);
          return;
        case 'TASK':
          navigate(`${ADMIN_ROUTES.tasks.view}/${id}/general`);
          return;
        default:
          return;
      }
    },
    [navigate]
  );

  const show = (msg: any) => {
    const { fullName, entityId, entityUuid, entityName, action, createDate } = msg;
    // TODO ensure createDate is send from BE
    notificationApi({
      type: 'info',
      message: (
        <Row className={styles.notification_content}>
          <Col span={24}>
            <Typography.Text>
              {fullName} {action.toLowerCase()} {capitalizeWords(entityName)}{' '}
              <Typography.Text
                ellipsis={{ tooltip: true }}
                underline
                className={styles.entity_id}
                onClick={() => onRedirectToEntity(entityId, entityName)}
              >
                {entityUuid}
              </Typography.Text>
              {NOTIFICATION_TYPE_MAPPING[action]}
            </Typography.Text>
          </Col>
          <Col span={24}>
            <Typography.Text type={'secondary'}>{dayjs(createDate).format('DD.MM.YYYY HH:mm')}</Typography.Text>
          </Col>
        </Row>
      ),
      icon: (
        <Row className={styles.icon_wrapper} align={'middle'} justify={'center'}>
          <NotificationsEmptyIcon color={'#FFFFFF'} />
        </Row>
      ),
      duration: 5,
    });
  };

  useNotifications(userId, show);

  return null;
}
